export function isElementFocusable(element: HTMLElement) {
	if (element.tabIndex > 0 || (element.tabIndex === 0 && element.getAttribute('tabIndex') !== null)) {
		return true;
	}

	const disabledAttribute = element.getAttribute && element.getAttribute('disabled');
	if (!element.getAttribute || (disabledAttribute && ['disabled', 'true', true].indexOf(disabledAttribute) >= 0)) {
		return false;
	}

	switch (element.nodeName) {
		case 'A':
			return !!element.getAttribute('href') && element.getAttribute('rel') !== 'ignore';
		case 'INPUT': {
			const typeAttribute = element.getAttribute('type');
			return typeAttribute && ['hidden', 'file'].indexOf(typeAttribute) <= 0;
		}
		case 'BUTTON':
		case 'SELECT':
		case 'TEXTAREA':
			return true;
		default:
			return false;
	}
}
